import React from 'react';
import { FiArrowUpRight } from 'react-icons/fi';
import config from '../config';

function ViewResume() {
  return (
    <a href={config.resumeLink}
       target="_blank"
       rel="noopener noreferrer"
       className="view-resume">
      View Full Résumé <FiArrowUpRight className="title-arrow" />
    </a>
  );
}

export default ViewResume; 